<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="FMEP"><span epub:type="pagebreak" id="pg_vii" title="vii">Objects have always been carried, sold, bartered, stolen, retrieved and lost. People have always given gifts. It is how you tell their stories that matters.</span></p>
<p class="FMEPC"><span class="ePub-I">—</span>Edmund de Waal, <span class="ePub-I">The Hare with Amber Eyes: A Family’s Century of Art and Loss</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7d437e93